import React, { useEffect, useState } from "react";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import Loader from "../../components/shared/Loader";
import { updateMeta } from "../../store/actions/metaAction";
import { useDispatch } from "react-redux";

const ModeratorShow = ({ match }) => {
	const {
		params: { moderatorID },
	} = match;

	const [name, setName] = useState("");
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [passwordConfirmation, setPasswordConfirmation] = useState("");
	const [loading, setLoading] = useState(true);
	const dispatch = useDispatch();

	useEffect(() => {
		onStart();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "تعديل تفاصيل المشرف",
				breadcrumb: "المشرفين",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
		axios
			.get(`${process.env.REACT_APP_API_URL}/users/${moderatorID}`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				setName(response.data.data.user.name);
				setEmail(response.data.data.user.email);
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
				setLoading(false);
			});
	};

	const handleSubmit = e => {
		e.preventDefault();
		if (password !== "" && password !== passwordConfirmation) {
			toast.error("كلمتي المرور غير متطابقتين!");
		} else {
			setLoading(true);
			axios
				.put(
					`${process.env.REACT_APP_API_URL}/users/${moderatorID}`,
					{
						name: name,
						email: email,
						password: password,
						password_confirmation: passwordConfirmation,
					},
					{
						headers: {
							Authorization: `Bearer ${cookie.get("token")}`,
							Accept: "application/json",
						},
					}
				)
				.then(function (response) {
					toast.success("تم تحديث بيانات المشرف بنجاح!");
					setLoading(false);
				})
				.catch(function (error) {
					toast.error("خطأ، برجاء المحاولة مره اخرى!");
					setLoading(false);
				});
		}
	};

	return (
		<section>
			{loading && <Loader />}
			<form onSubmit={handleSubmit}>
				<div className="row">
					<div className="col-md-6">
						<div className="form-item">
							<label htmlFor="name">الاسم</label>
							<input
								id="name"
								type="text"
								onChange={e => setName(e.target.value)}
								required
								value={name}
							/>
						</div>
					</div>
					<div className="col-md-6">
						<div className="form-item">
							<label htmlFor="email">البريد الالكتروني</label>
							<input
								id="email"
								type="email"
								onChange={e => setEmail(e.target.value)}
								required
								value={email}
							/>
						</div>
					</div>
					<div className="col-md-6">
						<div className="form-item">
							<label htmlFor="password">كلمة المرور</label>
							<input
								id="password"
								type="password"
								onChange={e => setPassword(e.target.value)}
							/>
						</div>
					</div>
					<div className="col-md-6">
						<div className="form-item">
							<label htmlFor="passwordConfirmation">اعادة كلمة المرور</label>
							<input
								id="passwordConfirmation"
								type="password"
								onChange={e => setPasswordConfirmation(e.target.value)}
							/>
						</div>
					</div>
				</div>
				<div className="form-item">
					<button className="bt bt-success">ارسال</button>
				</div>
			</form>
		</section>
	);
};

export default ModeratorShow;
